import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

const BYU_NAVY = "#002E5D";

function MyNavbar() {
    return (
        <Navbar expand="lg" style={{ background: BYU_NAVY, boxShadow: "0 2px 8px rgba(0,0,0,0.03)" }} variant="dark">
            <Container fluid>
                <Navbar.Brand as={Link} to="/" style={{ color: "#fff", letterSpacing: 1 }}>
                    Adam Griffin
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="main-navbar-nav" />
                <Navbar.Collapse id="main-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link as={Link} to="/">Home</Nav.Link>
                        <Nav.Link as={Link} to="/projects">Projects</Nav.Link>
                        <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
                        <Nav.Link as={Link} to="/about">About</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default MyNavbar;